import { IncentiveService } from '../../services/incentive.service';
import { AuthGuardService } from '../../services';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { Component, ViewChild, OnInit } from '@angular/core';
import { ExcelService } from '../../services/excel.service';
import { MatSort, MatPaginator } from '@angular/material';

// Vista risultati del Sistema Incentivante 2025 (REC Coordinator / RAP / CM),
// sostituisce BonusComponent (src/app/incentive/bonus/) come vista mostrata sotto
// la card "Bonus" del modulo Incentive (vedi incentive.component.html). Il vecchio
// componente resta nel progetto invariato per riferimento/rollback, ma non è più
// collegato dalla rotta hash "#/bonus".
//
// Struttura ricalcata da bonus.component.ts (mat-table, filtro mese/testo, ruoli,
// export Excel, gestione mese chiuso), con due differenze principali:
// 1) passa sempre da IncentiveService invece di chiamare HttpClient direttamente
//    (bonus.component.ts aveva un'incongruenza di URL tra il service e la chiamata
//    diretta - vedi piano di implementazione, sezione Frontend 4.1);
// 2) due trigger di calcolo separati (mensile / trimestrale) invece di uno solo,
//    perché il nuovo motore calcola le due cose con endpoint ed effetti distinti.
@Component({
  selector: 'app-bonus2025',
  templateUrl: './bonus2025.component.html',
  styleUrls: ['./bonus2025.component.css', '../incentive.component.css']
})
export class Bonus2025Component implements OnInit {

  displayedColumns = [
    'codClinica', 'nomeClinica', 'isTargetClinic', 'mese', 'idProfilo', 'LoginUtente',
    'bonusMensileProduzione', 'bunusMensilePerc', 'bonusSkyIsTheLimit', 'bonusPricing',
    'bonusTrimestrale', 'bonusQualityTrimestrale', 'bonusEfficienzaTrimestrale',
    'ConguaglioTrimestrale', 'DettaglioCalcoloMensile', 'UltimoCalcoloDT'
  ];
  // Navigazione a tab: implementata a mano invece di mat-tab-group perché il tema
  // globale (assets/dentalpro/css/base.css: .mat-tab-body {display:grid !important},
  // .mat-tab-body-content {overflow:hidden !important}) nascondeva il contenuto dei
  // tab diversi dal primo e le etichette oltre le prime due.
  tabs = [
    { id: 'risultati', label: 'Risultati' },
    { id: 'datiCm', label: 'Dati Trimestrali CM' }
  ];
  activeTab = 'risultati';
  dataSource: any;
  role: string = '';
  dm: string = '';
  fromDate: any;
  isAdmin: boolean = false;
  isAM: boolean = false;
  isDM: boolean = false;
  isCM: boolean = false;
  isViewer: boolean = true;
  showb: boolean;
  usr: any;
  kwSearch: any;
  isReadOnly: boolean = false;

  @ViewChild(MatSort, null) sort: MatSort;
  @ViewChild(MatPaginator, null) paginator: MatPaginator;

  constructor(
    private incentiveService: IncentiveService,
    private auth: AuthGuardService,
    private excelService: ExcelService) {
    this.fromDate = new Date();
    this.dataSource = new MatTableDataSource();
  }

  onSearch(e) {
    this.dataSource.filter = (e || '').trim().toLowerCase();
  }

  export() {
    if (this.isViewer === true) {
      window.alert('Il tuo profilo non permette questa funzione.');
      return;
    }
    this.excelService.exportAsExcelFile(this.dataSource.data, 'incentive_bonus_2025_' + this.fromDate.toLocaleString('default', { month: 'long' }));
  }

  init(from, to) {
    this.showb = true;
    const py = {
      from: from,
      to: to,
      desc_domain: this.dm,
      profile: this.role,
      usr: this.usr
    };

    this.incentiveService.getAllBonus2025(py).subscribe(res => {
      this.showb = false;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.dataSource.data = res;

      const closeDate = new Date(this.incentiveService.dataRepoGceEnvironment.ultima_chiusura_incentive);
      if (this.fromDate.getFullYear() >= closeDate.getFullYear()) {
        this.isReadOnly = false;
      } else {
        this.isReadOnly = this.fromDate.getMonth() < closeDate.getMonth();
      }

      this.dataSource.filterPredicate = (data: any, filterValue: string) => {
        const clinica = (data.codClinica || '').trim().toLowerCase();
        const profilo = (data.idProfilo || '').trim().toLowerCase();
        const login = (data.LoginUtente || '').trim().toLowerCase();
        return clinica.indexOf(filterValue) >= 0 || profilo.indexOf(filterValue) >= 0 || login.indexOf(filterValue) >= 0;
      };
    }, err => {
      this.showb = false;
      window.alert('Errore nel recupero delle informazioni dal DB. ' + err['message']);
    });
  }

  calcMensile() {
    if (this.isReadOnly === true) {
      window.alert('Il mese è chiuso, non è possibile calcolare i bonus.');
      return;
    }
    const ms = this.fromDate.toLocaleString('default', { month: 'long' });
    if (!window.confirm('Sei sicuro di voler calcolare i bonus mensili (REC Coordinator/RAP/CM) per il mese di ' + ms + '?')) {
      return;
    }
    this.showb = true;
    const py = {
      from: moment(this.fromDate).startOf('month').format('YYYYMMDD'),
      to: moment(this.fromDate).endOf('month').format('YYYYMMDD'),
      desc_domain: null
    };
    this.incentiveService.calcBonusMensile2025(py).subscribe(res => {
      this.init(py.from, py.to);
      window.alert('Calcolo mensile terminato.');
    }, err => {
      this.showb = false;
      const msg = (err && err.error && err.error.Message) ? err.error.Message : (err && err.error) ? err.error : (err && err['message']);
      window.alert('Errore nel calcolo mensile. ' + msg);
    });
  }

  calcTrimestrale() {
    if (this.isReadOnly === true) {
      window.alert('Il mese è chiuso, non è possibile calcolare i bonus.');
      return;
    }
    const ms = this.fromDate.toLocaleString('default', { month: 'long' });
    if (!window.confirm('Sei sicuro di voler calcolare i bonus trimestrali (conguaglio, produzione, qualità, efficienza) per il trimestre che si chiude a ' + ms + '?\nVa eseguito solo sul mese di chiusura trimestre (marzo/giugno/settembre/dicembre).')) {
      return;
    }
    this.showb = true;
    const py = {
      from: moment(this.fromDate).startOf('month').format('YYYYMMDD'),
      to: moment(this.fromDate).endOf('month').format('YYYYMMDD'),
      desc_domain: null
    };
    this.incentiveService.calcBonusTrimestrale2025(py).subscribe(res => {
      this.init(py.from, py.to);
      window.alert('Calcolo trimestrale terminato.');
    }, err => {
      this.showb = false;
      const msg = (err && err.error && err.error.Message) ? err.error.Message : (err && err.error) ? err.error : (err && err['message']);
      window.alert('Errore nel calcolo trimestrale. ' + msg);
    });
  }

  fromDateChange(e) {
    this.init(moment(this.fromDate).startOf('month').format('YYYYMMDD'), moment(this.fromDate).endOf('month').format('YYYYMMDD'));
  }

  closeM() {
    const det = new Date();
    if (window.confirm('Sei sicuro di voler chiudere il mese di lavoro in data ' + moment(det).format('DD/MM/YYYY') + '?')) {
      this.incentiveService.setCloseDate(det).subscribe(() => {
        window.alert('Mese chiuso correttamente');
      });
    }
  }

  // Spiegazione generale della regola (uguale per tutte le righe): i numeri
  // specifici del singolo caso sono invece nella colonna "Dettaglio calcolo".
  info(msg: string) {
    window.alert(msg);
  }

  ngOnInit() {
    const usr = this.auth.getUser();
    if (usr != null) {
      this.role = usr['ruolo'];
      this.dm = usr['clinica'];
      if (usr['nomeCompleto'] != null && usr['nomeCompleto'].length > 0) {
        this.usr = usr['nomeCompleto'];
      } else if (usr['email'] != null && usr['email'].length > 0) {
        this.usr = usr['email'];
      }
    }

    // Stesso schema di ruoli usato da bonus.component.ts/target.component.ts/
    // avanzamenti.component.ts (duplicato qui, non centralizzato - il piano di
    // implementazione lo segnala come miglioramento consigliato ma non bloccante,
    // sezione Frontend 4.5).
    if (this.role != null) {
      if (this.role.toLowerCase().indexOf('amministratore') === 0 || this.role.toLowerCase().indexOf('hr medici') === 0 || this.role.toLowerCase().indexOf('direzione') === 0) {
        this.isAdmin = true; this.isAM = false; this.isCM = false; this.isDM = false; this.isViewer = false;
      } else if (this.role.toLowerCase().indexOf('area') === 0 && this.role.toLowerCase().indexOf('manager') > 0) {
        this.isAdmin = false; this.isAM = true; this.isCM = false; this.isDM = false; this.isViewer = false;
      } else if (this.role.toLowerCase().indexOf('district') === 0 && this.role.toLowerCase().indexOf('manager') > 0) {
        this.isAdmin = false; this.isAM = false; this.isCM = false; this.isDM = true; this.isViewer = false;
      } else if (this.role.toLowerCase().indexOf('clinic') === 0 && this.role.toLowerCase().indexOf('manager') > 0) {
        this.isAdmin = false; this.isAM = false; this.isCM = true; this.isDM = false; this.isViewer = false;
      } else {
        this.isAdmin = false; this.isAM = false; this.isCM = false; this.isDM = false; this.isViewer = true;
      }
    } else {
      this.isAdmin = false; this.isAM = false; this.isCM = false; this.isDM = false; this.isViewer = false;
    }

    this.init(moment().startOf('month').format('YYYYMMDD'), moment().endOf('month').format('YYYYMMDD'));
  }
}
